/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/minigame-wrapper/minigame-wrapper',['require','jquery','underscore','core/base-screen','backbone','core/templates'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var BaseScreen = require('core/base-screen');
  var Backbone = require('backbone');
  var templates = require('core/templates');

  /*****************************************************************************************************************///}

  var MiniGameWrapper = BaseScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    stepIndex: -1,
    delay: 700,
    currentScore: 0,
    highScore: 0,
    scorePrefix: '',
    scoreSuffix: '',

    gameState: '',
    miniGameClass: null,
    miniGameTemplate: null,
    miniGameData: null,

    regions: {
      miniGameRegion: '.minigame-container'
    },
    ui: {
      btns: '.btn',
      introOverlay: '.intro-overlay',
      outroOverlay: '.outro-overlay',
    },
    events: {
      'click @ui.btns': 'btnPressed',
      'mouseover @ui.btns': 'btnOver',
      'mouseout @ui.btns': 'btnOut'
    },

    initialize: function(options)
    {
      //console.log('MiniGameWrapper::initialize');
      BaseScreen.prototype.initialize.apply(this, arguments);
    },

    loadMiniGame: function(page)
    {
      //console.log('MiniGameWrapper::loadMiniGame');
      this.miniGameTemplate = templates['minigames/' + this.model.get('minigame').view];

      //load game class
      var className = this.model.get('minigame').type;
      //console.log('className', className.toLowerCase());
      require(['minigames/' + className.toLowerCase()],
        _.bind(this.onMiniGameLoadedHandler, this),
        _.bind(this.onMiniGameFailedHandler, this)
      );
    },

    onMiniGameLoadedHandler: function(MiniGameClass)
    {
      //console.log('MiniGameWrapper::onMiniGameLoadedHandler', MiniGameClass);
      this.miniGameClass = MiniGameClass;

      //load game data
      var miniGameDataPath = this.model.get('minigame').data + '.json';
      require(['json!minigames/' + miniGameDataPath],
        _.bind(this.onMiniGameDataLoaded, this),
        _.bind(this.onMiniGameDataFailed, this)
      );
    },

    onMiniGameFailedHandler: function(err)
    {
      console.error('MiniGameWrapper::onMiniGameFailed: Class not found: ', err);
    },

    onMiniGameDataLoaded: function(data)
    {
      //console.log('MiniGameWrapper::MiniGameDataLoaded');
      this.miniGameData = data;
      _.delay(_.bind(this.miniGameReady, this), 1000);
    },

    miniGameReady: function()
    {
      //console.log('minigame::ready');
      TweenLite.to(this.ui.introOverlay.find('.btn-play'), 1, { autoAlpha: 1 });
    },

    startGame: function()
    {
      //show new view
      this.miniGameRegion.show(new this.miniGameClass(
      {
        model: new Backbone.Model(this.miniGameData),
        template: this.miniGameTemplate
      }));
      this.miniGameView = this.miniGameRegion.currentView;
      this.prevGameScore = this.page.get('earnedPoints') || 0;
      this.listenTo(this.miniGameView, 'gamestate.changed', this.onGameStateChangeHandler);
    },

    onMiniGameDataFailed: function(err)
    {
      //console.log('MiniGameWrapper::onMiniGameDataFailed: ', err);
    },

    onShow: function()
    {
      this.playMedia();
      this.loadMiniGame();
    },

    onGameStateChangeHandler: function(state)
    {
      //console.log('MiniGameWrapper::onGameStateChangeHandler', state);
      this.gameState = this.miniGameView.currentState;
      switch (this.gameState)
      {
        case 'minigame.end':
          this.setScore();
          this.showOutro();
          this.destroyMiniGame();
          break;
      }
    },

    showIntro: function()
    {
      TweenLite.set(this.ui.introOverlay, { autoAlpha: 1 });
    },

    hideIntro: function()
    {
      TweenLite.set(this.ui.introOverlay, { autoAlpha: 0 });
    },

    showOutro: function()
    {
      var increase = this.miniGameView.score - this.prevGameScore;
      increase = increase < 0 ? 0 : increase;
      this.ui.outroOverlay.find('.previous .score-value').html(this.prevGameScore);
      this.ui.outroOverlay.find('.new .score-value').html(this.miniGameView.score);
      this.ui.outroOverlay.find('.increase .score-value').html(increase);
      TweenLite.set(this.ui.outroOverlay, { autoAlpha: 1 });
      this.finish();
      this.radio.trigger('set.bookmark');
    },

    hideOutro: function()
    {
      TweenLite.set(this.ui.outroOverlay, { autoAlpha: 0 });
    },

    setScore: function()
    {
      //console.log('set score');
      var prevScore = this.page.get('earnedPoints') || 0;
      if (this.miniGameView.score > prevScore)
      {
        //this.model.set('earnedPoints', this.miniGameView.score);
        this.page.set('earnedPoints', this.miniGameView.score);
      }
    },

    destroyMiniGame: function()
    {
      if (this.miniGameView)
        this.miniGameView.cleanup();
      if (this.miniGameRegion)
        this.miniGameRegion.empty();
    },

    onBeforeDestroy: function()
    {
      this.destroyMiniGame();
      BaseScreen.prototype.onBeforeDestroy.apply(this, arguments);
    },

    btnPressed: function(e)
    {
      var btn = $(e.currentTarget);
      if (btn.hasClass('disabled'))
        return;

      if (btn.hasClass('btn-play'))
      {
        this.startGame();
        this.hideIntro();
      }
      else if (btn.hasClass('btn-replay'))
      {
        this.startGame();
        this.hideOutro();
      }
    },

    btnOver: function(e)
    {
      var btn = $(e.currentTarget);
      if (btn.hasClass('disabled'))
        return;

      btn.addClass('over');
    },

    btnOut: function(e)
    {
      var btn = $(e.currentTarget);
      btn.removeClass('over');
    },

    finish: function()
    {
      this.page.finish();
    }

  /*****************************************************************************************************************///}

  });

  return MiniGameWrapper;

});

